// const devMode = true
const devMode = false

export default devMode


// WEBPACK FOOTER //
// ./src/config/devMode.js